import { addAlert } from '../../../../MsgNotify/msgNotifyActions';
import { httpPost, httpGet, httpPut, httpDelete } from '../../../../Util/http';

export const SET_REDUCER_STATE = 'SET_REDUCER_STATE';
export const setState = (key, val) => {
	return {
		type: SET_REDUCER_STATE,
		key: key,
		val: val
	}
}

export const SET_PICTURE = 'SET_PICTURE'
export const setPicture = (pic, index) => {
	return {
		type: SET_PICTURE,
		pic: pic,
		index: index
	};
}

export const getPictures = workplaceId => {
	const url = process.env.REACT_APP_webApiEndPoint + `api/file/workplace/${workplaceId}/photos?coverImages=true`;
	return dispatch => {
		return httpGet(url)
			.then(response => {
				return response.json();
			})
			.then(json => {
				try { //if json is undefined
					if (json != null) {
						dispatch(setPicture({ ...json[0] }, 0));
						dispatch(setPicture({ ...json[1] }, 1))
					}
				} catch (e) {/*ignore*/ }
			})
			.catch(() => {
				dispatch(addAlert("Kunne ikke hente alle billeder til arbejdssted"))
			})
	}
}

export const ACTIVATE_FORM = 'ACTIVATE_FORM';
export const activateForm = val => {
	return {
		type: ACTIVATE_FORM,
		val: val
	}
}

export const edit = val => {
	return dispatch => {
		dispatch(activateForm(val));
	}
}

export const SAVE_DESCRIPTION_REQUEST = 'SAVE_DESCRIPTION_REQUEST'
export const saveDescriptionRequest = () => {
	return {
		type: SAVE_DESCRIPTION_REQUEST
	};
}

export const SAVE_DESCRIPTION_SUCCESS = 'SAVE_DESCRIPTION_SUCCESS'
export const saveDescriptionSuccess = (text) => {
	return {
		type: SAVE_DESCRIPTION_SUCCESS,
		text: text
	}
}

export const SAVE_DESCRIPTION_FAILURE = 'SAVE_DESCRIPTION_FAILURE'
export const saveDescriptionFailure = () => {
	return {
		type: SAVE_DESCRIPTION_FAILURE
	}
}

export const submit = (workplaceId, form) => {
	var saveDescription = () => { return new Promise(resolve => { resolve() }) };
	var uploadPic1 = () => { return new Promise(resolve => { resolve() }) };
	var uploadPic2 = () => { return new Promise(resolve => { resolve() }) };
	// eslint-disable-next-line
	if (form.pics[0].type == 'create') {
		uploadPic1 = () => postPicPromise(workplaceId, form.pics[0].original, form.pics[0].description)
		// eslint-disable-next-line
	} else if (form.pics[0].type == 'delete') {
		uploadPic1 = () => deletePicPromise(form.pics[0].oldId)
		// eslint-disable-next-line
	} else if (form.pics[0].type == 'replace') {
		uploadPic1 = () => putPicPromise(form.pics[0], 0, form.pics[0].description)
	}

	// eslint-disable-next-line
	if (form.pics[1].type == 'create') {
		uploadPic2 = () => postPicPromise(workplaceId, form.pics[1].original, form.pics[0].description)
		// eslint-disable-next-line
	} else if (form.pics[1].type == 'delete') {
		uploadPic2 = () => deletePicPromise(form.pics[1].oldId)
		// eslint-disable-next-line
	} else if (form.pics[1].type == 'replace') {
		uploadPic2 = () => putPicPromise(form.pics[1], 1, form.pics[0].description)
	}

	return dispatch => {
		dispatch(saveDescriptionRequest());
		if (form.text != null) {
			saveDescription = () => saveDescriptionPromise(workplaceId, form.text)
		}
		saveDescription()
			.then(
				uploadPic1()
					.then((pic) => {
						if (pic != null) dispatch(setPicture(pic, 0))
					})
					.then(
						uploadPic2()
							.then((pic) => {
								if (pic != null) dispatch(setPicture(pic, 1))
							})
					)
					.then(
						dispatch(saveDescriptionSuccess(form.text))
					)
					.catch(() => {
						dispatch(saveDescriptionFailure())
						dispatch(addAlert('kunne ikke gemme beskrivelse, prøv igen'))
					})
			)
	}
}

const saveDescriptionPromise = (workplaceId, text) => {
	const uploadDescriptionURL = process.env.REACT_APP_webApiEndPoint + `api/workplace/${workplaceId}/description`;
	return httpPut(uploadDescriptionURL, { description: text });
}

const putPicPromise = (pic) => {
	const uploadURL = process.env.REACT_APP_webApiEndPoint + `api/file/${pic.oldId}`;
	return new Promise((resolve, reject) => {
		httpPut(uploadURL, {
			fileContent: pic.original,
			coverImage: true
		})
			.then(response => response.json())
			.then(resp => {
				return updateDescriptionRequest(resp, pic.description)
					.then(() => resp)
					.catch(() => resp)
			})
			.then(
				(id) => { pic.id = id; resolve(pic) },
				() => reject()
			);
	});
}

const postPicPromise = (workplaceId, dataurl, filename) => {
	const uploadURL = process.env.REACT_APP_webApiEndPoint + "api/file/workplace/" + workplaceId;
	return new Promise((resolve, reject) => {
		httpPost(uploadURL, {
			fileContent: dataurl,
			coverImage: true
		})
			.then(response => response.json())
			.then(resp => {
				return updateDescriptionRequest(resp, filename)
					.then(() => resp)
					.catch(() => resp)
			})
			.then(
				(id) => { resolve({ id: id, original: dataurl, thumbnail: dataurl, description: filename }) },
				() => reject()
			);
	});
}

const deletePicPromise = (picId) => {
	const uploadURL = process.env.REACT_APP_webApiEndPoint + `api/file/${picId}`;
	return httpDelete(uploadURL);
}

const updateDescriptionRequest = (imageId, text) => {
	var url = process.env.REACT_APP_webApiEndPoint + "api/file/" + imageId + "/description";
	return httpPut(url, { description: text })
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/description/actions.js